import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall, formattedPrice} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import moment from "moment";
class MySubsciption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payment:[],
      isLoad:true,
      loading:false,
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getPayment();
  }
  getPayment = async () => {
    try {
      const response = await apiCall('business/get-payment','get',null);

      this.setState({payment:response},()=>{
        this.setState({isLoad:false})
      });
    }catch (e) {
      console.log(e);
      this.setState({isLoad:false});
    }
  }
  cancelSubsription = async (event) => {
    const {id} = event.target;
    var url = "business/iyzico/cancel-subscription";
    var title = "Üyeliğinizi iptal istediğinize emin misiniz?"
    var title1 = "İptal Edildi!"
    var html = "Üyeliğiniz İptal Edilmiştir!"

    if (id === 'active'){
       url = "business/iyzico/active-subscription";
       title = "Üyeliğinizi aktif etmek istediğinize emin misiniz?"
       title1 = "Aktif Edildi!"
       html = "Üyeliğiniz Aktif Edilmiştir!"
    }
    const result = await Swal.fire({
      title: title,
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet!',
      cancelButtonText: 'Hayır'
    });

    if (result.isConfirmed) {
      try {

        await apiCall(url,'get',null);

        Swal.fire(
            title1,
            html,
            'success'
        );

      } catch (error) {
        Swal.fire(
            'Hata!',
            error.response.data.errorMessage,
            'error'
        );
      }
    }
  }
  formattedDate = (date) => {
    return mainHelper.dateFormat(moment(date).format("YYYY-MM-DD HH:mm:ss"));
  }
  render() {
    const {payment} = this.state;
    const desc = payment.payment ? payment.payment.product.description.split(',') : [];
    const pricingPlan = payment.payment ? JSON.parse(payment.payment.product.pricingPlans) : {};
    const details = payment.payment ? JSON.parse(payment.payment.details) : {};
    var matchingPlan = {}
    if (payment.payment && pricingPlan) {
      matchingPlan = pricingPlan.find(plan => plan.referenceCode === payment.payment.refCode);
    }
    const paymentData = payment.payment ? payment.payment : [];
    const buyer = payment.payment ? payment.payment.buyer : [];
    const product = payment.payment ? payment.payment.product : [];
    var status = payment.payment ? payment.payment.subscriptionStatus : '';

    if (status === "ACTIVE"){
      status = "Aktif";
    }else {
      status = "Pasif";
    }
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader"
                 style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="servicezone"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Üyelik Detayları"
                Breadcrumb={[
                  {name: "Ayarlar", navigate: ""},
                  {name: "Üyelik", navigate: ""},
                ]}
            />

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  {paymentData && Object.keys(paymentData).length > 0 ? (
                      <div className="body text-center">
                        <div className="row clearfix">
                          <div className="col-lg-6 col-md-12">
                            <h6><i className="icon-credit-card"></i> Üyelik Bilgileri</h6>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="float-right">
                              <button
                                  className={`mr-2 btn btn-outline-${status === 'Aktif' ? 'success' : 'danger'}`}>Üyelik
                                Durumu : {status}<i
                                    className={`ml-1 icon-${status === 'Aktif' ? 'check' : 'ban'}`}></i></button>
                              <a href="/settings/subscription" className="btn btn-outline-info"><i
                                  className="icon-arrow-up"></i> Pro Abonelik</a>
                            </div>
                          </div>
                        </div>
                        <hr/>
                        <div className="col-lg-12 justify-content-center"
                             style={{display: "grid", gridTemplateColumns: " 1fr 1fr", gap: 10}}>

                          <div className="grid-item">
                            <small className="text-muted">Müşteri Adı:</small>
                            <p>{buyer && (buyer.name)}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Müşteri Soyadı: </small>
                            <p>{buyer && (buyer.surname)}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Üyelik Planı:</small>
                            <p>{product.name}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Deneme Başlangıç:</small>
                            <p>{this.formattedDate(details.trialStartDate)}</p>
                          </div>

                          <div className="grid-item">
                            <small className="text-muted">Üyelik Planı: </small>
                            <p>{matchingPlan && (matchingPlan.paymentInterval === "MONTHLY" ? "Aylık" : "Yıllık")}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Deneme Bitiş:</small>
                            <p>{this.formattedDate(details.trialEndDate)}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Fiyat: </small>
                            <p>{matchingPlan && (formattedPrice(matchingPlan.price))}</p>
                          </div>

                          <div className="grid-item">
                            <small className="text-muted">Oluşturulma tarihi: </small>
                            <p className="m-b-0">{mainHelper.dateFormat(paymentData.created_at)}</p>
                          </div>
                          <div className="grid-item">
                            <small className="text-muted">Üyelik Detayı: </small>
                            {desc.map((d, i) => {
                              return <p key={i}>{d}</p>
                            })}
                          </div>
                          <div className="grid-item">
                            <small
                                className="text-muted">{status === 'Aktif' ? 'Üyelik İptali' : 'Üyeliği Aktifleştir'}: </small>
                            <p>
                              <button id={status === 'Aktif' ? 'cancel' : 'active'} onClick={this.cancelSubsription}
                                      className={`btn btn-outline-${status === 'Aktif' ? 'danger' : 'success'}`}>{status === 'Aktif' ? 'İptal et' : 'Aktifleştir'}</button>
                            </p>
                          </div>

                        </div>

                      </div>
                  ) : (
                      <>
                        <div className="body text-center">
                          <div className="alert alert-warning text-center">Henüz aktif Pro üyeliğiniz bulunmamaktadır.</div>
                      <a href="/settings/subscription" className="btn btn-outline-info">Pro Pakete Geç</a>
                      </div>
                      </>
                  )}

                </div>
                </div>
              </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(MySubsciption);
